import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.SectionReportTypeLineItem', {
    integrationSectionTitle: '{integrationName} Workflows',
    standaloneSectionTitle: 'Standalone workflows',
});
